import './component';
import './preview';

Shopware.Service('cmsService').registerCmsBlock({
    name: 'acris-blog-content',
    label: 'acris-blog.blocks.blogContent.label',
    category: 'acris-blog',
    component: 'sw-cms-block-acris-blog-content',
    previewComponent: 'sw-cms-preview-acris-blog-content',
    defaultConfig: {
        marginBottom: '20px',
        marginTop: '20px',
        marginLeft: null,
        marginRight: null,
        sizingMode: 'boxed'
    },
    slots: {
        column: {
            type: 'acris-blog-content'
        },
    }
});
